import { useMemo } from 'react';
import { useLocalLoginInfo } from '@cont/Login/Context/LoginLocalInfo';
import useLoginStore from '@stores/login/loginStore';
import { getOtpOrEmailResponse } from '@stores/selectors/login';

import constants, {
  LOGIN_METHOD_EMAIL_OTP,
  LOGIN_METHOD_EMAIL_PHONE_OTP
} from '@cont/Login/constants';

const useLoginOTPMessage = () => {
  const otpOrEmailResponse = useLoginStore(getOtpOrEmailResponse);
  const { accountType, sourceType, step } = useLocalLoginInfo();

  const message = useMemo(() => {
    let subHeading = '';
    subHeading =
      accountType === constants.ACCOUNT_TYPE_LOGIN
        ? "We've sent an OTP to your registered mobile number"
        : "We've sent an OTP to your mobile number";
    if (otpOrEmailResponse?.phone) {
      subHeading = `We've sent an OTP to your registered mobile number ${otpOrEmailResponse.phone}`;
    }
    if (otpOrEmailResponse?.login_method === LOGIN_METHOD_EMAIL_OTP)
      subHeading = "We've sent an OTP to your email";

    if (otpOrEmailResponse?.email)
      subHeading = `We've sent an OTP to your email ${otpOrEmailResponse.email}`;

    if (otpOrEmailResponse?.login_method === LOGIN_METHOD_EMAIL_PHONE_OTP)
      subHeading = `We've sent an OTP to your email${
        otpOrEmailResponse.email ? ` ${otpOrEmailResponse.email}` : ''
      } and registered mobile number${
        otpOrEmailResponse.phone ? ` ${otpOrEmailResponse.phone}` : ''
      }`;

    if (sourceType === 'marketing') {
      subHeading = 'Enter the 6 digit OTP sent to your mobile number';
    }

    if (step === constants.UPDATE_PARTIAL_USER_DETAILS_STEP) {
      subHeading = 'Enter few details to complete sign up';
    }

    return subHeading;
  }, [otpOrEmailResponse, sourceType, accountType, step]);
  return message;
};

export default useLoginOTPMessage;
